export default __webpack_public_path__ + "static/Rene-d6238f4fdcdc6195d1fb9f4dfe128fdb.jpeg";